<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <playlists-table></playlists-table>
      <playlist-editor></playlist-editor>
    </v-layout>
  </v-container>
</template>

<script>
import PlaylistsTable from './PlaylistsTable.vue';
import PlaylistEditor from './PlaylistEditor.vue';

export default {
  components: {
    PlaylistsTable,
    PlaylistEditor,
  },
};
</script>

<style scoped>

</style>
